import React, { ReactElement } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useAuthStore } from "../store/useAuthStore";
import AdminLayout from "../components/layout/AdminLayout";
import AdminDashboard from "../features/dashboard/AdminDashboard";
import UserDirectory from "../features/user-directory/UserDirectory";
import UserDetail from "../features/user-directory/UserDetail";
import Subscriptions from "../features/subscriptions/Subscriptions";
import PaymentHistory from "../features/history/PaymentHistory";
import SearchHistory from "../features/history/SearchHistory";
import AdminLogin from "../features/auth/Login";
import AdminSettings from "../features/settings/AdminSettings";
import SalesEnquiries from "../features/sales-enquiries/SalesEnquiries";
import SupportTickets from "../features/support-tickets/SupportTickets";
import SystemHealth from "../features/system-health/SystemHealth";
import Coupons from "../features/coupons/Coupons";
import SerperKeys from "../features/serper-keys/SerperKeys";

const ProtectedRoute = ({ children }: { children: ReactElement }) => {
  const { isAuthenticated } = useAuthStore();
  if (!isAuthenticated) return <Navigate to="/login" replace />;
  return children;
};

function DashboardRoutes(): ReactElement {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<AdminLogin />} />
        <Route element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
          <Route path="/"                element={<AdminDashboard />} />
          <Route path="/users"           element={<UserDirectory />} />
          <Route path="/users/:userId"   element={<UserDetail />} />
          <Route path="/subscriptions"   element={<Subscriptions />} />
          <Route path="/coupons"         element={<Coupons />} />
          <Route path="/sales-enquiries" element={<SalesEnquiries />} />
          <Route path="/support-tickets" element={<SupportTickets />} />
          <Route path="/system-health"   element={<SystemHealth />} />
          <Route path="/payments"        element={<PaymentHistory />} />
          <Route path="/searches"        element={<SearchHistory />} />
          <Route path="/settings"        element={<AdminSettings />} />
          <Route path="/serper-keys"     element={<SerperKeys />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default DashboardRoutes;
